import React, { useRef, Fragment, useState } from 'react';

import { useReactToPrint } from 'react-to-print';
import { Grid, Divider } from '@material-ui/core';
import { Print } from '@material-ui/icons';

import { ButtonGeneric } from '../atoms/Buttons';
import { useTotem } from '../../../hooks/useCases/useTotem';
import { Redirect } from "react-router-dom";

export const GenericPrint = ({ listItems, label = "primary", buttonSize = "medium", confirmaTurno, item, afiliado, handleClose }) => {
    const componentRef = useRef();
    const totem = useTotem();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    const [redirect, setRedirect] = useState(false);


    const DividerItem = () => <Grid item xs={12} component={Divider} />;

    const confirm = () => {
        if (confirmaTurno === true && item.confirmado !== true) {
            totem.insert.confirmTurnoAfiliado(
                { idAgenda: item.id, idAfiliado: afiliado.id_afiliado, piso: item.piso }, { id: item.id, confirmado: true }, handleClose
            )
        }
        setRedirect(true)

    }

    const handleButtonClick = () => {
        handlePrint(); // Llama a la función de impresión
        confirm(); // Llama a la función de confirmación
    }

    return (
        <>
            {redirect && (
                <Redirect
                    to={{
                        pathname: '/',
                        state: {
                            from: '/'
                        },
                    }}
                />
            )}
            <ButtonGeneric
                type="button"
                text={label}
                startIcon={<Print />}
                color="primary"
                onClick={handleButtonClick}
                size={buttonSize}
            />
            <div style={{ display: 'none' }}>
                <Grid ref={componentRef} container>
                    {listItems.filter(({ filter }) => !filter).map(({ children }, index) => (
                        <Fragment key={index}>
                            {children && (
                                <>
                                    <Grid item xs={12} style={{ padding: "1em" }}>
                                        {children}
                                    </Grid>
                                    {(listItems.length - 1) !== index && (<DividerItem />)}
                                </>
                            )}
                        </Fragment>
                    ))}
                </Grid>
            </div>
        </>
    )
};